import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJcPowerMoveSpinner = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 435,
	height: 587,
	viewBox: "0 0 435 587",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.00012207 161.967L13.6628 424.371L96.0173 371.824L186.314 513.131L186.409 513.297V513.202L177.261 260.891L96.2773 312.635L0.00012207 161.967Z",
			fill: "white",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.3257 129.584L52.996 408.417L137.832 365.301L212.93 527.835L213.025 528.048V527.93L226.829 260.42L143.411 302.897L63.3257 129.584Z",
			fill: "url(#paint0_linear_1_885)",
			fillOpacity: .6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.921 97.1758L94.5989 392.437L181.894 358.776L241.816 542.561L241.887 542.774V542.679L278.644 259.946L192.814 293.158L128.921 97.1758Z",
			fill: "url(#paint1_linear_1_885)",
			fillOpacity: .7
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M194.517 64.793L136.202 376.482L225.979 352.23L270.678 557.265L270.749 557.525L270.772 557.407L330.482 259.475L242.194 283.42L194.517 64.793Z",
			fill: "url(#paint2_linear_1_885)",
			fillOpacity: .8
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M260.088 32.3848L177.804 360.502L270.039 345.705L299.563 571.991L299.61 572.251L299.634 572.133L382.296 259.025L291.573 273.68L260.088 32.3848Z",
			fill: "url(#paint3_linear_1_885)",
			fillOpacity: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M325.683 0L219.407 344.546L314.1 339.18L328.449 586.693L328.472 587L328.496 586.882L434.11 258.551L340.977 263.941L325.683 0Z",
			fill: "url(#paint4_linear_1_885)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_1_885",
				x1: 44.2341,
				y1: 319.628,
				x2: 231.999,
				y2: 338.473,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "white" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .04,
						stopColor: "#FFF7F5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .16,
						stopColor: "#FFE3DA"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .23,
						stopColor: "#FFDCD1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .35,
						stopColor: "#FFE0D1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .48,
						stopColor: "#FFEFD3"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .66,
						stopColor: "#FFF0D8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .75,
						stopColor: "#FFF2DD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .9,
						stopColor: "#FFFBF5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "white"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_1_885",
				x1: 101.613,
				y1: 312.874,
				x2: 272.34,
				y2: 328.191,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "white" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .03,
						stopColor: "#FFF4F1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .12,
						stopColor: "#FFD4C6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .19,
						stopColor: "#FFC0AB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .23,
						stopColor: "#FFB9A2"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .31,
						stopColor: "#FFBDA2"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4,
						stopColor: "#FFCBA4"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .48,
						stopColor: "#FFDFA7"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6,
						stopColor: "#FFE0AC"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .74,
						stopColor: "#FFE5BB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .75,
						stopColor: "#FFE6BC"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .84,
						stopColor: "#FFF1DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .94,
						stopColor: "#FFFBF5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "white"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_1_885",
				x1: 141.677,
				y1: 304.44,
				x2: 325.394,
				y2: 318.942,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "white" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .08,
						stopColor: "#FFD1C3"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .15,
						stopColor: "#FFB098"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .2,
						stopColor: "#FF9C7D"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .23,
						stopColor: "#FF9574"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .29,
						stopColor: "#FF9974"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .36,
						stopColor: "#FFA775"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .44,
						stopColor: "#FFBF78"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .48,
						stopColor: "#FFCF7A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .57,
						stopColor: "#FED07F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .68,
						stopColor: "#FED58E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .75,
						stopColor: "#FED99A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .79,
						stopColor: "#FEE1B1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .88,
						stopColor: "#FEF1DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .96,
						stopColor: "#FEFBF5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "white"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_1_885",
				x1: 181.745,
				y1: 296.151,
				x2: 378.072,
				y2: 309.605,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "white" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .05,
						stopColor: "#FFDBD0"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .11,
						stopColor: "#FFAE94"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .17,
						stopColor: "#FF8D69"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .21,
						stopColor: "#FF794E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .23,
						stopColor: "#FF7245"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .28,
						stopColor: "#FF7645"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .34,
						stopColor: "#FF8547"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .41,
						stopColor: "#FF9C49"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .47,
						stopColor: "#FFBC4D"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .48,
						stopColor: "#FFBF4E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .55,
						stopColor: "#FEC053"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .65,
						stopColor: "#FEC562"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .75,
						stopColor: "#FECD79"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .83,
						stopColor: "#FEE1B0"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .91,
						stopColor: "#FEF1DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .96,
						stopColor: "#FEFBF5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "white"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_1_885",
				x1: 221.831,
				y1: 287.87,
				x2: 430.363,
				y2: 300.092,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "white" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .01,
						stopColor: "#FFF2EF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .07,
						stopColor: "#FFB9A3"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .13,
						stopColor: "#FF8B66"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#FF6A3B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .21,
						stopColor: "#FF5620"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .23,
						stopColor: "#FF4F17"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .28,
						stopColor: "#FF5317"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .33,
						stopColor: "#FF6219"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .39,
						stopColor: "#FF791B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .45,
						stopColor: "#FF991F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .48,
						stopColor: "#FFAF22"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .55,
						stopColor: "#FEB027"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .63,
						stopColor: "#FEB536"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .72,
						stopColor: "#FEBD4E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .75,
						stopColor: "#FEC057"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .78,
						stopColor: "#FECB76"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .86,
						stopColor: "#FEE1B0"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .92,
						stopColor: "#FEF1DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .97,
						stopColor: "#FEFBF5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "white"
					})
				]
			})
		] })
	]
});
export default SvgJcPowerMoveSpinner;
